"use strict";

exports.__esModule = true;
exports.UpdateTicketWatcherRuleScreen = UpdateTicketWatcherRuleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _API = require("../../API");
var _TicketWatcherRuleForm = require("../TicketWatcherRuleForm");
var _System = require("../../../System");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function UpdateTicketWatcherRuleScreen(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
    collection: props.collection,
    id: props.match.params.id
  }, function (_ref) {
    var fetching = _ref.fetching,
      data = _ref.data;
    if (fetching || !data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("UpdateTicketWatcherRuleScreen.title.loading", "Loading Ticket Watcher Rule...")
      }, /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("UpdateTicketWatcherRuleScreen.title", "Edit {name}", {
        name: data.name
      })
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("UpdateTicketWatcherRuleScreen.navbar.title", "Edit {name}", {
        name: data.name
      })
    }), /*#__PURE__*/_react["default"].createElement(_TicketWatcherRuleForm.TicketWatcherRuleForm, {
      initialValues: {
        name: data.name,
        enabled: data.enabled,
        from: data.from,
        to: data.to,
        types: data.types,
        daysOfTheWeek: data.daysOfTheWeek,
        devices: data.devices.filter(function (item) {
          return item.type === "UUID";
        }).map(function (item) {
          return item.value;
        }),
        deviceTags: data.devices.filter(function (item) {
          return item.type === "TAG";
        }).map(function (item) {
          return item.value;
        }),
        users: data.watchers.filter(function (item) {
          return item.type === "USER";
        }).map(function (item) {
          return item.value;
        }),
        emails: data.watchers.filter(function (item) {
          return item.type === "EMAIL";
        }).map(function (item) {
          return item.value;
        }),
        actions: data.actions
      },
      onSubmit: function onSubmit(_ref2) {
        var name = _ref2.name,
          enabled = _ref2.enabled,
          from = _ref2.from,
          to = _ref2.to,
          types = _ref2.types,
          daysOfTheWeek = _ref2.daysOfTheWeek,
          devices = _ref2.devices,
          deviceTags = _ref2.deviceTags,
          users = _ref2.users,
          emails = _ref2.emails,
          actions = _ref2.actions;
        return props.collection.updateWithoutID({
          id: data.id,
          name: name,
          enabled: enabled,
          from: from,
          to: to,
          types: types,
          daysOfTheWeek: daysOfTheWeek,
          devices: devices.map(function (value) {
            return {
              type: "UUID",
              value: value
            };
          }).concat(deviceTags.map(function (value) {
            return {
              type: "TAG",
              value: value
            };
          })),
          watchers: users.map(function (value) {
            return {
              type: "USER",
              value: value
            };
          }).concat(emails.map(function (value) {
            return {
              type: "EMAIL",
              value: value
            };
          })),
          actions: actions.length <= 0 ? _constants.ACTION_TYPES.map(function (actionType) {
            return actionType.id;
          }) : actions
        }).then(function () {
          props.onSave();
          props.history.push((0, _System.getScreenLocation)("TicketWatcherRuleList"));
        });
      },
      onDelete: function onDelete() {
        return props.collection["delete"](data.id).then(function () {
          props.onDelete();
          props.history.push((0, _System.getScreenLocation)("TicketWatcherRuleList"));
        });
      }
    }));
  });
}